<template>
  <div class="value-logo">
    <img :src="Logo" class="light-only" />
    <img :src="LogoWhite" class="dark-only" />
  </div>
</template>

<script>
import Logo from '../images/cardladder-value-logo.svg?inline';
import LogoWhite from '../images/cardladder-value-logo-white.svg?inline';

export default {
  data() {
    return {
      Logo,
      LogoWhite,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

img {
  height: var(--value-logo-size, 12px);
  width: auto;
  float: left;
}
</style>
